import * as React from 'react';

import EmptyData from '../../components/EmptyData/EmptyData';
import KeyActivityTable from './KeyActivityTable';
import LinearProgress from '@material-ui/core/LinearProgress';

import './style.scss';

interface Props {
  activityData: any;
  isLoading: boolean;
  currentProductLabel: string;
}

function KeyActivity (props: Props) {

  const {
    currentProductLabel,
    isLoading,
    activityData,
  } = props;

  return(
    <div className='d-flex flex-column key-activity-container'>
      <span className='page-head'>
        {`${currentProductLabel} Key Activity`}
      </span>
      {
        isLoading ?
          <div className='loader-container key-activity-load'>
            <LinearProgress color='primary' />
          </div>
          :
          activityData.data.length > 0 && !isLoading ?
            <div className='d-flex flex-column key-activity-wrapper'>
              <KeyActivityTable activityData={activityData} />
            </div> :
            <EmptyData
              message='No data found for Communication' />
      }
    </div>
  );
  
}

export default React.memo(KeyActivity);
